import { useParams } from "react-router-dom";
import servicesData from "../data/servicesData";
// import CallToAction from "./CallToAction";
import CancellationPolicy from "../components/CancellationPolicy";
import SpotlightCard from "../components/SpotlightCard";
import { Link } from "react-router-dom";
import Availability from "./Availability";

function ServiceDetails() {
	const { serviceId } = useParams(); // Get the service ID from the URL
	const service = servicesData[serviceId]; // Retrieve the service data

	if (!service) {
		return <p>Service not found.</p>; // Handle case where service is not found
	}

	return (
		<section className="serviceDetailsSection desktopMaxWidth">
			<div className="sectionHeroContainer">
				<p className="sectionHeroTitle">{service.title}</p>
				<p className="sectionHeroText">Services / {service.title}</p>
			</div>
			<div className="serviceDetailsContent">
				<p className="introText">{service.text}</p>

				<div className="serviceDetail">
					<p className="tag ">Details</p>
					<p>{service.serviceDetails.serviceDetails}</p>
				</div>
				<div className="serviceDetail">
					<p className="tag ">What to Expect</p>
					<p>{service.serviceDetails.howItWorks}</p>
				</div>
				<div className="serviceDetail">
					<p className="tag ">Key Points</p>
					<ul className="keyPoints">
						{service.serviceDetails.keyPoints.map((point, index) => (
							<li key={index}>{point}</li>
						))}
					</ul>
				</div>
				<div className="serviceDetail">
					<p className="tag ">Other Information</p>
					<p>{service.serviceDetails.otherInfo}</p>
				</div>
				<Availability />
			</div>

			<div className="pricingAndPolicy">
				<Link
					to={service.href}
					aria-label="Book an Appointment"
					// target="_blank"
					// rel="noopener noreferrer"
				>
					<SpotlightCard
						className="custom-spotlight-card"
						spotlightColor="rgba(0, 229, 255, 0.2)"
					>
						<div className="spotLightCardContentContainer">
							<div className="spotLightCardContent">
								<p className="serviceType">{service.title}</p>
								<p>{service.serviceDetails.otherInfo}</p>
							</div>
							<div className="pricingContainer spotlightCardSubContainer">
								<i className="fa-solid fa-dollar"></i>
								<p>{service.pricing}</p>
							</div>
							<div className="durationContainer spotlightCardSubContainer">
								<i className="fa-solid fa-clock"></i>
								<p>{service.duration}</p>
							</div>
						</div>
						<p className="cta ctaSecondary ctaThird">Book Now</p>
					</SpotlightCard>
				</Link>
				<CancellationPolicy />
			</div>
			{/* <CallToAction /> */}
		</section>
	);
}

export default ServiceDetails;
